// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__qk0ZE","rootCenter":"LoadMoreObserver_rootCenter__3k8_U","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__dX4iH"};